import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { OpenVehicleSelectionButtonComponent } from '@app/vehicle-selection/components/open-vehicle-selection-button.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-welcome-screen',
  imports: [CommonModule, TranslocoPipe, OpenVehicleSelectionButtonComponent],
  template: `
    <div class="mb-32 flex w-full flex-col gap-6 pt-8 md:pt-12 lg:pt-16">
      <div>
        <h1 class="mb-2 text-3xl font-semibold" data-testid="welcome-screen-heading">
          <ng-container *ngIf="user()?.profile?.first_name">
            {{ 'welcomeScreen.createFirstThread.heading' | transloco }}, {{ user()?.profile?.first_name }}!
          </ng-container>
          <ng-container *ngIf="!user()?.profile?.first_name">{{ 'welcomeScreen.createFirstThread.heading' | transloco }}!</ng-container>
        </h1>

        <p class="mb-6 text-lg text-gray-700">
          {{ 'welcomeScreen.createFirstThread.text' | transloco }}
        </p>
        <app-open-vehicle-selection-button class="" />
      </div>

      <h2 class="pt-8 text-2xl font-semibold">
        {{ 'welcomeScreen.features.heading' | transloco }}
      </h2>

      <div class="flex flex-col gap-6 xl:flex-row">
        <div class="flex-1 rounded-lg bg-green-50 p-6">
          <h3 class="mb-1 text-lg font-semibold">
            {{ 'welcomeScreen.features.box1.name' | transloco }}
          </h3>
          <p class="flex-grow text-sm text-gray-700">
            {{ 'welcomeScreen.features.box1.text' | transloco }}
          </p>
          <p class="mt-4 text-sm text-green-800">
            {{ 'welcomeScreen.features.box1.keywords' | transloco }}
          </p>
        </div>

        <div class="flex-1 rounded-lg bg-green-50 p-6">
          <h3 class="mb-1 text-lg font-semibold">
            {{ 'welcomeScreen.features.box2.name' | transloco }}
          </h3>
          <p class="flex-grow text-sm text-gray-700">
            {{ 'welcomeScreen.features.box2.text' | transloco }}
          </p>
          <p class="mt-4 text-sm text-green-800">
            {{ 'welcomeScreen.features.box2.keywords' | transloco }}
          </p>
        </div>

        <div class="flex-1 rounded-lg bg-green-50 p-6">
          <h3 class="mb-1 text-lg font-semibold">
            {{ 'welcomeScreen.features.box3.name' | transloco }}
          </h3>
          <p class="flex-grow text-sm text-gray-700">
            {{ 'welcomeScreen.features.box3.text' | transloco }}
          </p>
          <p class="mt-4 text-sm text-green-800">
            {{ 'welcomeScreen.features.box3.keywords' | transloco }}
          </p>
        </div>
      </div>

      <!-- <h2 class="flex justify-between pt-8 text-2xl font-semibold">
        {{ 'welcomeScreen.news.heading' | transloco }}

        <div class="flex gap-2">
          <p-button size="small" icon="pi pi-chevron-left" (click)="newsCarousel.navBackward($event)" severity="secondary"></p-button>
          <p-button size="small" icon="pi pi-chevron-right" (click)="newsCarousel.navForward($event)" severity="secondary"></p-button>
        </div>
      </h2>

      <div class="relative h-[370px] min-h-[370px] flex-1 overflow-hidden">
        <p-carousel
          #newsCarousel
          class="absolute inset-0"
          [value]="[
            {
              itemImageSrc: 'assets/images/logo_HaynesPro_16x16.png',
              data: { date: '16.10.2025', name: ('welcomeScreen.news.box1.name' | transloco), text: ('welcomeScreen.news.box1.text' | transloco) },
            },
            {
              itemImageSrc: 'assets/images/logo_HaynesPro_16x16.png',
              data: { date: '12.08.2025', name: ('welcomeScreen.news.box2.name' | transloco), text: ('welcomeScreen.news.box2.text' | transloco) },
            },
            {
              itemImageSrc: 'assets/images/logo_HaynesPro_16x16.png',
              data: { date: '16.10.2025', name: ('welcomeScreen.news.box3.name' | transloco), text: ('welcomeScreen.news.box3.text' | transloco) },
            },
            {
              itemImageSrc: 'assets/images/logo_HaynesPro_16x16.png',
              data: { date: '12.08.2025', name: ('welcomeScreen.news.box4.name' | transloco), text: ('welcomeScreen.news.box4.text' | transloco) },
            },
          ]"
          [numVisible]="2.5"
          [numScroll]="1"
          [circular]="false"
          [showNavigators]="false"
          [responsiveOptions]="responsiveOptions">
          <ng-template pTemplate="item" let-item>
            <div class="m-2 h-[310px] rounded-2xl shadow">
              <div class="flex h-full flex-col">
                <img [src]="item.itemImageSrc" [alt]="" class="mb-4 h-32 w-full rounded-t-2xl object-cover" />
                <div class="p-1">
                  <h3 class="truncate text-lg font-semibold">{{ item.data.name }}</h3>
                  <p class="text-sm text-gray-400">{{ item.data.date }}</p>
                  <p class="mt-2 flex-grow text-sm text-gray-700">{{ item.data.text }}</p>
                </div>
              </div>
            </div>
          </ng-template>
        </p-carousel>
      </div> -->
    </div>
  `,
})
export class WelcomeScreenComponent {
  user = input<any>(null);

  responsiveOptions = [
    { breakpoint: '1199px', numVisible: 3, numScroll: 1 },
    { breakpoint: '991px', numVisible: 2, numScroll: 1 },
    { breakpoint: '767px', numVisible: 1, numScroll: 1 },
  ];
}
